import { GenreGroupMenuBookInfoType, IMenu, ITenpoInfo, MenuBookGroupInfoType } from 'apis/types';
import { DisplayTimingGroupResults } from 'utils/displayTimingGroup';
import { getMenuAllYouCanEat, isMenuSlotRendered } from 'utils';

export function checkGenreAvailable(
  menuInfo: MenuBookGroupInfoType,
  genreId: string,
  menuData?: IMenu,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _tenpoInfo?: ITenpoInfo,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _timeFrameLunch?: string[],
  displayTimingGroupResults: DisplayTimingGroupResults = {},
  shinagire: string[] = []
): boolean {
  const genreMenu: GenreGroupMenuBookInfoType[] =
    menuInfo?.course && menuInfo.course !== null ? getMenuAllYouCanEat(menuInfo) : menuInfo.genre ?? [];

  const targetGenre = genreMenu.find((genre) => genre.genre_id === genreId);
  if (!targetGenre) return false;

  return targetGenre.subgenre.some((subgenre) =>
    subgenre.menu?.some((menuSlot) => isMenuSlotRendered(menuSlot, menuData, shinagire, displayTimingGroupResults))
  );
}
